import script from "./UserProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfilePage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__